import React from "react";
import GymFightersAboutLogo from "../../../assets/GymFightersLogo.png";
import "./GymFightersAbout.css";

const GymFightersAbout = () => {
  return (
    <div className="Gym-Fighters-About-Page">
      <a
        href="http://sagwanwood.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={GymFightersAboutLogo}
          alt="GymFighters Logo"
          className="Gym-Fighters-About-Page-Logo"
        />{" "}
      </a>
      <div className="Gym-Fighters-About-Page-Container">
        <h1 className="Gym-Fighters-About-Page-Title">GymFighters.com</h1>
        <p className="Gym-Fighters-About-Page-Description">
          GymFighters.com transcends the concept of fitness; it embodies a realm
          where dedication doesn't just shape destinies; it forges them.
          <br />
          <br />
          Immerse yourself in a world where fitness transcends routine to become
          an unwavering ethos. Our extensive array of fitness equipment isn't
          just machinery; it's a catalyst for transformative change.
          <br />
          <br />
          Count on GymFighters.com not only to equip gyms but to shape futures.
          It's a commitment etched in iron, a promise forged in sweat, and a
          partnership fortified by unwavering determination.
        </p>
      </div>
    </div>
  );
};

export default GymFightersAbout;
